import React from 'react';
import '../styles/SelectionChip.css';

function SelectionChip(props) {
    const label = props.label;
    const selected = props.selected;
    const disabled = props.disabled;
    const func = props.func;
    const index = props.index;
    const leftIcon = props.leftIcon;
    const rightIcon = props.rightIcon;
    const darkMode = props.darkMode;
    const unselectedClass = darkMode === true ? "selection-chip-unselected-dark " : "selection-chip-unselected ";
    const selectedClass = darkMode === true ? "selection-chip-selected-dark " : "selection-chip-selected ";

    return (
        <div 
            className={"selection-chip-outer-container " + (selected === true ? selectedClass : unselectedClass) + (disabled === true ? "disabled" : func === null ? "selection-chip-no-click" : "cursor-pointer")}
            onClick={() => disabled === false ? func === null ? null : func(index) : null}
        >
            <div className="selection-chip-inner-container">
                {
                    leftIcon !== null &&
                    leftIcon
                }
                <span className={"body-regular block-text text-align-center" + (darkMode === true ? " colour-white" : " colour-primary")}>
                    {label}
                </span>
                {
                    rightIcon !== null &&
                    rightIcon
                }
            </div>
        </div>
    )
};

export default SelectionChip;